import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-consulta-duplicidade-chassi-motor',
  templateUrl: './consulta-duplicidade-chassi-motor.component.html',
  styleUrls: ['./consulta-duplicidade-chassi-motor.component.scss']
})
export class ConsultaDuplicidadeChassiMotorComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  @Input() token = '';

  constructor() { }

  ngOnInit() { }

  ngOnChanges() {
    this.setStatus();
  }

  setStatus(){

    if(this.consulta && (this.consulta.lista==null || this.consulta.lista.length<=1)) {
      this.statusMsg = 'NÃO CONSTA OCORRÊNCIA';
      this.status = 'info';
    }

    if(this.consulta.lista.length==2) {
      this.statusMsg = "FOI ENCONTRADO 1 "  + " VEÍCULO COM O MESMO NÚMERO DE MOTOR";
      this.status = 'info';
    }

    if(this.consulta.lista.length>2){
      this.statusMsg = "FORAM ENCONTRADOS " +  this.consulta.lista.length + " VEÍCULOS COM O MESMO NÚMERO DE MOTOR";
      this.status = 'info';
    }

  }

}
